import { ISLBatchPostBody } from "../schemas/SLBatchPostBody";
import { ISLBatchHeader } from "../components/SLBatch/SLBatchHeader";
import { IAttachment } from "../schemas/SLAttachment";
import { ISLBatchValidationErrors } from "../components/SLBatch/SLBatchValidationErrors";
import { ISLBatchResponse } from "../components/SLBatch/SLBatchSchemas";

interface BatchStoreInterface {
  entryHeaderData: ISLBatchHeader;
  attachmentsListData: IAttachment[];
  validationErrors: ISLBatchValidationErrors;
}

export class SLBatchEntryFactory {
  public getSLBatchPostBody(
    batchId: number,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    slBatchEntry: any,
    batchFile: IAttachment,
    batchRefGUID: string | null,
    batchRowVer: ArrayBuffer | null
  ): ISLBatchPostBody {
    const slBatchPostBody: ISLBatchPostBody = {
      id: batchId,
      batchName: slBatchEntry.batchName,
      batchDescription: slBatchEntry.batchDescription,
      purpose: slBatchEntry.purpose,
      batchFileInfo: batchFile,
      attachmentInfo: slBatchEntry.attachmentsList
    };
    if (batchRefGUID) {
      slBatchPostBody.refGUID = batchRefGUID;
    }
    if (batchRowVer) {
      slBatchPostBody.rowVer = batchRowVer;
    }
    return slBatchPostBody;
  }

  public mapBatchDataToStoreInterfaces(batchEntry: ISLBatchResponse): BatchStoreInterface {
    const headerData = {
      file: null,
      batchFileInfo: batchEntry.batchFileInfo,
      name: batchEntry.batchName,
      description: batchEntry.batchDescription,
      purpose: batchEntry.purpose,
      refGUID: batchEntry.refGUID
    };
    const validationErrorData: ISLBatchValidationErrors = {
      errors: batchEntry.validationErrors
    };
    const entryHeaderData = headerData as ISLBatchHeader;
    const attachmentsListData = batchEntry.attachmentInfo as IAttachment[];
    const validationErrors = validationErrorData as ISLBatchValidationErrors;
    return {
      entryHeaderData,
      attachmentsListData,
      validationErrors
    };
  }
}

export const slBatchEntryFactory = new SLBatchEntryFactory();
